<h2 data-cy="edit-item-title" matDialogTitle>Edit {{ productName }}</h2>
<form [formGroup]="hireItemForm" (submit)="save()">
  <mat-dialog-content>
    <div class="edit-dialog flex flex-col">
      <h2 class="pb-4">On Hire Details</h2>
      <div class="flex flex-row">
        <mat-form-field class="product-name basis-1/3">
          <mat-label>Quantity</mat-label>
          <input matInput formControlName="quantity" type="number" name="Quantity" placeholder="Quantity" />
        </mat-form-field>
      </div>
      <div class="flex flex-col md:flex-row md:space-x-2 justify-start items-stretch md:justify-start md:items-start">
        <mat-form-field>
          <mat-label>On hire date</mat-label>
          <input matInput formControlName="on_hire" name="On hire date" [matDatepicker]="onHirePicker"
            [max]="maximumDate" placeholder="On hire date" />
          <mat-error *ngIf="hireItemForm.controls.on_hire.hasError('matDatepickerMax')">
            On hire date can not be more than today's date
          </mat-error>
          <mat-datepicker-toggle matSuffix [for]="onHirePicker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #onHirePicker></mat-datepicker>

        <mat-form-field>
          <mat-label>On hire time</mat-label>
          <input matInput name="on_hire_time" formControlName="on_hire_time"
            (blur)="updateTimeEnteredManually('on_hire_time', pickerH)" placeholder="On hire time" />
          <mat-error *ngIf="hireItemForm.get('on_hire_time').hasError('invalidTime')">Invalid time value, please enter
            in the format: HH:mm (24
            hour)</mat-error>
          <mat-icon matSuffix (click)="pickerH.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'on_hire_time')" #pickerH></ngx-mat-timepicker>



        <mat-form-field>
          <mat-label>Location out</mat-label>
          <mat-select placeholder="Location out" name="Location out" id="location" formControlName="location_out"
            required="true">
            <mat-option *ngFor="let location of locations" [value]="location.id">{{ location.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <h2 class="pb-4">Off Hire Details</h2>
      <div class="flex flex-col justify-start items-stretch md:flex-row md:space-x-2" *ngIf="!offHire">
        <mat-form-field class="basis-full">
          <mat-label>Est. off hire date</mat-label>
          <input data-cy="est-off-hire" matInput formControlName="estimated_off_hire" name="Estimated off hire"
            autocomplete="off" [matDatepicker]="estOffHirePicker" placeholder="Est. off hire date" />
          <mat-datepicker-toggle matSuffix [for]="estOffHirePicker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #estOffHirePicker></mat-datepicker>

        <mat-form-field class="basis-full">
          <mat-label>Est. off hire time</mat-label>
          <input matInput name="estimated_off_hire_time" formControlName="estimated_off_hire_time"
            (blur)="updateTimeEnteredManually('estimated_off_hire_time', pickerEstOff)"
            placeholder="Est. off hire time" />
          <mat-error *ngIf="hireItemForm.get('estimated_off_hire_time').hasError('invalidTime')">Invalid time value,
            please enter in the format: HH:mm (24
            hour)</mat-error>
          <mat-icon matSuffix (click)="pickerEstOff.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'estimated_off_hire_time')" #pickerEstOff></ngx-mat-timepicker>
      </div>
      <div class="flex flex-col justify-start items-stretch md:flex-row md:space-x-2" *ngIf="offHire">
        <mat-form-field class="basis-full">
          <mat-label>Off hire date</mat-label>
          <input matInput formControlName="off_hire" name="Off hire date" autocomplete="off"
            [matDatepicker]="offHirePicker" placeholder="Off hire date" required />
          <mat-datepicker-toggle matSuffix [for]="offHirePicker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #offHirePicker></mat-datepicker>

        <mat-form-field class="basis-full">
          <mat-label>Off hire time</mat-label>
          <input matInput name="off_hire_time" formControlName="off_hire_time"
            (blur)="updateTimeEnteredManually('off_hire_time', pickerOff)" placeholder="Off hire time" />
          <mat-error *ngIf="hireItemForm.get('off_hire_time').hasError('invalidTime')">Invalid time value, please enter
            in the format: HH:mm (24
            hour)</mat-error>
          <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
        </mat-form-field>
        <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
          (timeSet)="updateTime($event, 'off_hire_time')" #pickerOff></ngx-mat-timepicker>


        <mat-form-field class="basis-full">
          <mat-label>Location in</mat-label>
          <mat-select placeholder="Location in" name="Location in" id="location" formControlName="location_in" required>
            <mat-option *ngFor="let location of locations" [value]="location.id">{{ location.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col md:flex-row justify-start md:items-center items-stretch md:space-x-6 my-4">
        <div class="md:basis-2/5 basis-full flex flex-col">
          <div class="mb-2"><strong>Pricing:</strong> {{ pricingSummary }}</div>
        </div>
        <button mat-stroked-button type="button" (click)="openPricingDetails()">Edit Pricing Details</button>
      </div>
      <div class="flex flex-col md:flex-row justify-start items-stretch md:justify-start md:items-stretch md:space-x-4">
        <mat-form-field class="md:basis-full">
          <mat-label>Additional notes</mat-label>
          <textarea matInput placeholder="Additional notes" formControlName="notes" name="Notes"
            cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="dialogRef.close()" type="button">
      Cancel
    </button>
    <button data-cy="save-edit" mat-raised-button color="primary" [disabled]="!hireItemForm.valid" type="submit">
      Save
    </button>
  </mat-dialog-actions>
</form>